
<ngx-spinner
  bdColor="#ffffff94"
  size="medium"
  color="#5d5bd7"
  type="ball-atom"
>
  <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>

<app-internet-connection-status />

<div class="relative h-full w-full">
  <router-outlet></router-outlet>

  <div *ngIf="sharedService.hasNetworkConnection" class="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
    <span class="text-white text-center text-lg font-medium">
      {{ 'CONNECTION_STATUS_OFFLINE' | translate }}
    </span>
  </div>
</div>
